/**
 * @fileoverview Model representing Google Group data used to render relevant group details
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

export class GoogleGroup {
  /**
   * @param {{
   *  id: string,
   *  name: string,
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
  }

  /**
   * @param {!GoogleGroupJson} json
   * @return {!GoogleGroup}
   */
  static fromJSON(json) {
    return new GoogleGroup({
      id: json['id'],
      name: json['name'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  id: string,
 *  name: string,
 * }}
 */
export var GoogleGroupJson;
